module.exports = __webpack_public_path__ + "img/partly_cloudy_day.5c211d88.svg";